<script lang="ts" setup>
withDefaults(defineProps<{
  thick?: boolean
  color?: string
  vertical?: boolean
}>(), { thick: false,color: 'text-grey-primary', })
</script>

<template>
  <div class="relative" :class="[color, vertical ? 'ml' : 'mt-2']">
    <div class="absolute inset-0 flex items-center" aria-hidden="true">
      <div
        :class="[
          vertical ? 'h-full' : 'w-full',
          vertical ? (thick ? 'border-l-2' : 'border-l') : (thick ? 'border-t-2' : 'border-t')
        ]"
      />
    </div>
    <slot/>
  </div>
</template>
